//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "ordercommit",
  data(){
      return {
        form:{
          order_id:0,
          major_score:0,
          interest_score:0,
          practical_score:0,
          mark:''
        }
      }
  },
  methods:{
    submit(){
      this.axios.post('/xcx/Order/mark',this.form).then(res=>{
        this.$router.go(-1);
      })
    }
  },
  created() {
      this.form.order_id=this.$route.query.orderid;
  }
}



// WEBPACK FOOTER //
// ./src/components/ordercommit/ordercommit.vue